import { createClient } from 'contentful';

export const PreviewClient = () => {
  return createClient({
    space: process.env.REACT_APP_CONTENTFUL_SPACE_ID,
    accessToken: process.env.REACT_APP_CONTENTFUL_PREVIEW_TOKEN,
    host: 'preview.contentful.com'
  });
};

export default () => {
  return createClient({
    space: process.env.REACT_APP_CONTENTFUL_SPACE_ID,
    accessToken: process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN
  });
};



// WEBPACK FOOTER //
// ./src/lib/Contentful.js